import { DeleteConfirmationModalComponent } from './DeleteConfirmationModal.types';
import { Flexbox, Modal, Typography } from '@hiiretail/synergy-ui';
import { StyledButton } from '../../../pages/GroupDetails/ui/modals/DeleteGroupModal/DeleteGroupModal.styles';

export const DeleteConfirmationModal: DeleteConfirmationModalComponent = ({
  title,
  entity,
  isOpen,
  onClose,
  isDeleting,
  deleteEntity,
  dataTestId,
}) => {
  return (
    <Modal
      data-testid={dataTestId}
      title={`Delete ${title}`}
      open={isOpen}
      onClose={onClose}
      footer={
        <Flexbox container justifyContent="flex-end">
          <StyledButton disabled={isDeleting} onClick={onClose} variant="secondary">
            No
          </StyledButton>
          <StyledButton disabled={isDeleting} onClick={deleteEntity} type="submit">
            Yes
          </StyledButton>
        </Flexbox>
      }
    >
      <Flexbox container item>
        <Typography>
          You are about to delete a {entity}, this operation can not be undone.
        </Typography>
      </Flexbox>
      <Flexbox container item>
        <Typography>Are you sure you want to proceed?</Typography>
      </Flexbox>
    </Modal>
  );
};
